import { FC, ReactElement } from 'react';
import { Chip, Stack, Tooltip, Typography } from '@mui/material';

// ==============================|| ADMINISTRATION CHIPS (celulă standard „Administrații") ||============================== //
// Afișare uniformă a administrațiilor în tabele: primul nume ca chip conturat (trunchiat +
// tooltip cu numele complet) și, dacă sunt mai multe, un chip albastru „+N" cu toate numele
// în tooltip. Extragerea numelor rămâne la apelant (sursa diferă între module —
// administrations / subscribedAdministrations / administrationName); aici doar afișarea.

const CHIP_SX = {
	maxWidth: 200,
	'& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' }
};

const MutedDash = (
	<Typography variant="body2" sx={{ color: 'text.secondary' }}>
		—
	</Typography>
);

export interface AdministrationChipsProps {
	/** Numele administrațiilor de afișat (goale/undefined sunt ignorate). */
	names: string[];
	/** Randare când lista e goală (default „—"). Ex.: chip „Platformă" pentru web-useri. */
	empty?: ReactElement;
}

export const AdministrationChips: FC<AdministrationChipsProps> = ({
	names,
	empty = MutedDash
}) => {
	const list = names.filter(Boolean);
	if (list.length === 0) return empty;
	if (list.length === 1) {
		return (
			<Tooltip title={list[0]}>
				<Chip label={list[0]} size="small" variant="outlined" sx={CHIP_SX} />
			</Tooltip>
		);
	}
	return (
		<Tooltip
			title={list.map((n) => (
				<div key={n}>{n}</div>
			))}
		>
			<Stack
				direction="row"
				sx={{ gap: 0.5, alignItems: 'center', width: 'fit-content' }}
			>
				<Chip label={list[0]} size="small" variant="outlined" sx={CHIP_SX} />
				<Chip
					label={`+${list.length - 1}`}
					size="small"
					variant="light"
					color="primary"
					sx={{ flexShrink: 0 }}
				/>
			</Stack>
		</Tooltip>
	);
};

AdministrationChips.defaultProps = {
	empty: undefined
};
